import { IApplicationStateSlice } from './types';

export const initialState: IApplicationStateSlice = {
    showWelcomeScreen: true,
    showCallbackToolTip: false,
    topupPolicyId: ''
};
